import {FC, useState, useEffect, useRef} from 'react'

import {Modal} from 'react-bootstrap'
import {clearLocalStorageExcept, dateTimeFormat} from 'thesis-and-dissertations/helpers/helper'
import Api from '../../../thesis-and-dissertations/helpers/api'

import HTMLRenderer from 'react-html-renderer'

import './style.css'

const api = new Api()

type Props = {
  showModal: boolean
  handleCloseModal: any
  privacyPolicy: any
}

const AlertContent: FC<Props> = ({showModal, handleCloseModal, privacyPolicy}) => {
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)

  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false)
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setShow(showModal)
  }, [showModal])

  const handleOk = () => {
    setLoading(true)
    api
      .storePrivacyPolicy({id: privacyPolicy?.id})
      .then((response: any) => {
        setLoading(false)
        handleCloseModal(false)
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  const handleScroll = () => {
    const div = scrollRef.current
    if (div && div.scrollTop + div.clientHeight >= div.scrollHeight - 10) {
      setHasScrolledToBottom(true)
    }
  }

  const logout = () => {
    clearLocalStorageExcept([])
    window.location.href = '/'
  }

  return (
    <Modal show={show} centered size='lg'>
      <Modal.Header>
        <p className='h6 px-3'>{privacyPolicy?.title}</p>
      </Modal.Header>

      <div
        className='px-10 mt-5 overflow-auto html-content'
        style={{maxHeight: '500px'}}
        ref={scrollRef}
        onScroll={handleScroll}
      >
        {privacyPolicy?.content ? (
          <HTMLRenderer html={privacyPolicy?.content} />
        ) : (
          <div className='text-center py-10'>
            <div className='spinner-border text-primary mb-3' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
            <p className='text-muted'>Memuat Kebijakan Privasi...</p>
          </div>
        )}
      </div>

      <div className='p-10'>
        <p style={{fontSize: '12px'}}>
          Dengan menggunakan aplikasi ini, Anda menyatakan telah membaca, memahami, dan menyetujui{' '}
          <a
            href='https://ebeasiswa-lpdp.kemenkeu.go.id/Home/Privacy'
            target='_blank'
            rel='noopener noreferrer'
          >
            <span className='fw-bold text-black'>Kebijakan Privasi</span>
          </a>{' '}
          yang berlaku.
        </p>

        <div className='d-flex justify-content-center gap-3 my-3'>
          <button
            className='btn btn-sm w-50 text-primary'
            style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
            onClick={logout}
          >
            Batal
          </button>

          <button
            className='btn btn-sm w-50 text-white'
            style={{background: ' var(--Primary-L-500, #F95E2F)'}}
            onClick={handleOk}
            disabled={!hasScrolledToBottom}
          >
            Saya Setuju
          </button>
        </div>

        <p className='mt-3' style={{fontSize: '12px'}}>
          *Silakan Scroll ke bawah dan baca seluruh Kebijakan Privasi. Tombol '
          <span className='fw-bold'>Saya Setuju</span>' akan aktif setelah Anda selesai membaca.
        </p>
      </div>
    </Modal>
  )
}

const AlertModal: FC<Props> = ({showModal, handleCloseModal, privacyPolicy}) => {
  return (
    <AlertContent
      showModal={showModal}
      handleCloseModal={handleCloseModal}
      privacyPolicy={privacyPolicy}
    />
  )
}

export default AlertModal
